import { getRatio, getMediaFileDuration } from "entities/media-files";
import { VIDEO_REEL_CONSTANTS } from "constants/VideoReelConstants";
import { PostMediaFile } from "shared/types/post";
import { AccountPlatformType } from "@/shared/types/accounts";

export interface VideoReelCriteria {
  hasVideo: boolean;
  isNineToSixteen: boolean;
  isShortDuration: boolean;
  hasSupportedPlatform: boolean;
}

export function isNineToSixteenRatio(mediaFile: PostMediaFile): boolean {
  const ratio = getRatio(mediaFile);
  return (
    ratio >= VIDEO_REEL_CONSTANTS.ASPECT_RATIO.MIN_NINE_TO_SIXTEEN &&
    ratio <= VIDEO_REEL_CONSTANTS.ASPECT_RATIO.MAX_NINE_TO_SIXTEEN
  );
}

export function getVideoReelCriteria(
  mediaFiles: PostMediaFile[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accounts: any[],
  selectedPlatform?: AccountPlatformType,
  currentValue?: string
): VideoReelCriteria {
  const hasVideo = mediaFiles.length === 1 && mediaFiles[0]?.isVideo === true;
  const isNineToSixteen =
    currentValue === VIDEO_REEL_CONSTANTS.POST_TYPES.REEL
      ? true
      : hasVideo
        ? isNineToSixteenRatio(mediaFiles[0])
        : false;

  let isShortDuration = false;
  if (hasVideo && mediaFiles[0]) {
    const duration = getMediaFileDuration(mediaFiles[0]);
    isShortDuration =
      currentValue === VIDEO_REEL_CONSTANTS.POST_TYPES.REEL
        ? true
        : duration
          ? duration <= VIDEO_REEL_CONSTANTS.DURATION.MAX_REEL_SECONDS
          : false;
  }

  const hasSupportedPlatform = selectedPlatform
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      VIDEO_REEL_CONSTANTS.SUPPORTED_PLATFORMS.includes(selectedPlatform as any)
    : accounts.some((acc) =>
        VIDEO_REEL_CONSTANTS.SUPPORTED_PLATFORMS.includes(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (acc.platformType || acc.platformName?.toUpperCase()) as any
        )
      );

  return {
    hasVideo,
    isNineToSixteen,
    isShortDuration,
    hasSupportedPlatform,
  };
}

export function shouldShowReelToggle(criteria: VideoReelCriteria): boolean {
  return (
    criteria.hasVideo &&
    criteria.isNineToSixteen &&
    criteria.hasSupportedPlatform
  );
}

export function getDefaultVideoPostType(
  criteria: VideoReelCriteria
): "video" | "reel" {
  return shouldShowReelToggle(criteria) && criteria.isShortDuration
    ? "reel"
    : "video";
}

export function isReelToggleEnabled(criteria: VideoReelCriteria): boolean {
  return shouldShowReelToggle(criteria) && criteria.isShortDuration;
}
